import * as L from "leaflet";
import { IBoundLayer, IBoundLayerOptions } from "../../../map/BoundLayer";
import {
  getFlightMarkersState,
  getSiteState,
} from "../../../redux/rootReducer";
import { createReactPopup } from "../../../map/popup";
import { getFlightMarkerById } from "../../../redux/modules/flightMarkers/flightMarkersReducer";
import config from "../../../config";
import CoordinatesFlightMarkerPopupContent from "../CoordinatesFlightMarkerPopupContent";
import * as React from "react";
import { feetToMeters } from "../../../utils";
import {
  getSiteSrs,
  isSiteImperial,
} from "../../../redux/modules/site/reducer";
import { MODE_PILOT_UI_ACTIVE_NAIL_SELECTED } from "../../../redux/modules/modePilotUi/reducer";
import { convertGlobalToWgs84Coords } from "../../../utils/coordinateConversion/convertGlobalToWgs84Coords";

export default class FlightMarkersNavigator
  extends L.LayerGroup
  implements IBoundLayer
{
  public options: IBoundLayerOptions;
  public map: L.Map;

  constructor(options: IBoundLayerOptions) {
    super();
    L.Util.setOptions(this, options);
  }

  public onAdd(map: L.Map) {
    L.LayerGroup.prototype.onAdd.call(this, map);
    this.map = map;
    return this;
  }

  public onRemove(map: L.Map) {
    L.LayerGroup.prototype.onRemove.call(this, map);
    this.map = null;
    return this;
  }

  public update(action: IAction<any>) {
    if (action.type !== MODE_PILOT_UI_ACTIVE_NAIL_SELECTED) {
      this.map.closePopup();
      return;
    }

    const flightMarkerId = action.payload;
    const flightMarkersState = getFlightMarkersState(this.options.getState());
    const flightMarker = getFlightMarkerById(
      flightMarkersState,
      flightMarkerId,
    );

    const srs = getSiteSrs(getSiteState(this.options.getState()));
    const { x, y, z } = convertGlobalToWgs84Coords(
      flightMarker.operatorCoords,
      srs,
    );
    this.map.setView([y, x], config.pointZoom);

    const siteState = getSiteState(this.options.getState());
    const isImperial = isSiteImperial(siteState);

    setTimeout(() => {
      this.map.openPopup(
        createReactPopup(
          <CoordinatesFlightMarkerPopupContent
            coordinates={{
              lat: y,
              lng: x,
              alt: isImperial ? feetToMeters(z) : z,
            }}
            name={flightMarker.name}
            closePopup={() => this.map.closePopup()}
          />,
        ).setLatLng({
          lat: y,
          lng: x,
        }),
      );
    }, 350);
    return;
  }
}
